import { useQuery } from "@apollo/client";
import { ME, MeResponse } from "../queries";
import { insertApiResponseDataDog, insertApiResponseDataDogError } from "utils";
import React from "react";

function useUser(isAthlete = false) {
  const { loading, data, error, refetch } = useQuery<MeResponse>(ME, {
    fetchPolicy: isAthlete ? "network-only" : "cache-first", // always fetch fresh data
    onError(error) {
      insertApiResponseDataDog("MEApi(error)", error, "error");
      insertApiResponseDataDogError(error, "MEApi(error)");
    },
  });

  // Run localStorage update only when user data changes
  React.useEffect(() => {
    if (data?.me) {
      insertApiResponseDataDog("MEApi(success)", data, "info");

      localStorage.setItem("LoginUserObject", JSON.stringify(data.me));
      localStorage.setItem("loginUserId", data.me.id);
      localStorage.setItem(
        "loginUserName",
        `${data.me.firstName} ${data.me.lastName}`
      );
      localStorage.setItem("loginUserEmail", data.me.email);
    }
  }, [data?.me]);

  return {
    ...data?.me,
    loading,
    error,
    refetch,
  };
}
export default useUser;
